import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { GET } from "../constants/request-type";
import { service_api } from "../constants/url";
import BlogBanner from "../elements/blog-banner";
import BlogBody from "../elements/blog-body";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import "../styles/layout-blog.css";

// image importation

import { useLocation } from "react-router-dom";

import { configureCrisp } from "../../utils/crispConfig";
import { createLogger } from "../../utils/logger";

const logger = createLogger("LayoutBlog");

const LayoutBlog = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [blog, setBlog] = useState([]);
  const [chefData, setChefData] = useState();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const selectedArticleId = searchParams.get("article");
  const selectedChefId = searchParams.get("chef");

  const lang = useSelector((state) => state.lang);
  const user = useSelector((state) => state.user);


  useEffect(() => {
    configureCrisp({
      autoload: true,
      lockMaximized: false,
      lockFullview: false
    });
    initialData();
  }, []);

  const initialData = async () => {

    if (!selectedArticleId) {
      return history.push("/");
    }

    const request_details_blog = {
      type: GET,
      url: service_api,
      route: `blog/get-one/${selectedArticleId}`,
      data: null,
      token: null
    };

    const request_details_chef = {
      type: GET,
      url: service_api,
      route: `user/get-chef-user/${selectedChefId}`,
      token: user?.refresh_token || null
    };

    try {
      // Fetch blog and chef data concurrently for better performance
      const [blogResponse, chefResponse] = await Promise.all([
        MakeRequestAsync(request_details_blog),
        MakeRequestAsync(request_details_chef)
      ]);

      // Decrypt both responses concurrently
      const [blogData, chefData] = await Promise.all([
        decryptSingleData(blogResponse.data.blog),
        decryptSingleData(chefResponse.data.user)
      ]);

      setBlog(blogData);
      setChefData(chefData);
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
      return history.push("/");
    }
  };

  return (
    <div className="global-block">
      <div
        className="full-block"
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >
        {/* Tu dois ajouter tout les autre compasant du projet ici */}
        <div className="CompleteBodyBlog">
          <BlogBanner
            chef_data={chefData}
            title={blog?.title}
            createdAt={blog?.createdAt}
            pic={blog?.pic}
            updatedAt={blog?.updatedAt}
            message={blog?.message}
          />
          <BlogBody message={blog?.message} />
        </div>
      </div>
      <div
        style={{
          height: 80
        }}
      ></div>
    </div>
  );
};

export default LayoutBlog;

